import { useMemo, useState, type FormEvent } from 'react';
import { Check, KeyRound, ShieldCheck } from 'lucide-react';
import { api, useAuth } from './auth';

export function ForcedPasswordChange(){
  const {user,csrfToken,refresh}=useAuth();
  const [passwords,setPasswords]=useState({current:'',next:'',confirm:''});
  const [busy,setBusy]=useState(false),[error,setError]=useState('');
  const checks=useMemo(()=>[
    {label:'8 or more characters',ok:passwords.next.length>=8},
    {label:'Uppercase letter',ok:/[A-Z]/.test(passwords.next)},
    {label:'Lowercase letter',ok:/[a-z]/.test(passwords.next)},
    {label:'Number',ok:/\d/.test(passwords.next)},
    {label:'Symbol',ok:/[^A-Za-z0-9]/.test(passwords.next)},
    {label:'Passwords match',ok:Boolean(passwords.next)&&passwords.next===passwords.confirm}
  ],[passwords]);
  async function submit(event:FormEvent<HTMLFormElement>){
    event.preventDefault();if(!csrfToken||checks.some(item=>!item.ok)||busy)return;
    setBusy(true);setError('');
    try{
      await api('/api/v1/profile/password',csrfToken,{method:'POST',body:JSON.stringify({currentPassword:passwords.current,newPassword:passwords.next,confirmPassword:passwords.confirm})});
      await refresh();
      window.location.replace('/dashboard');
    }catch(value){setError(value instanceof Error?value.message:'Password could not be changed.');setBusy(false)}
  }
  return <main className="password-gate">
    <section className="password-gate-card">
      <header><img src="/realco-wordmark.png" alt="Realco"/><span><ShieldCheck/>Protected account setup</span></header>
      <div className="password-gate-copy"><KeyRound/><div><h1>Create your permanent password</h1><p>{user?.displayName}, replace the temporary password before entering your workspace.</p></div></div>
      {error&&<div className="form-error" role="alert">{error}</div>}
      <form onSubmit={submit} noValidate>
        <label>Current temporary password<input type="password" autoComplete="current-password" value={passwords.current} onChange={event=>setPasswords(current=>({...current,current:event.target.value}))} required minLength={8}/></label>
        <label>New password<input type="password" autoComplete="new-password" value={passwords.next} onChange={event=>setPasswords(current=>({...current,next:event.target.value}))} required minLength={8}/></label>
        <label>Repeat new password<input type="password" autoComplete="new-password" value={passwords.confirm} onChange={event=>setPasswords(current=>({...current,confirm:event.target.value}))} required minLength={8}/></label>
        <div className="password-rules">{checks.map(item=><span className={item.ok?'ok':''} key={item.label}><Check/>{item.label}</span>)}</div>
        <button className="button primary full" disabled={busy||!passwords.current||checks.some(item=>!item.ok)}>{busy?'Securing account…':'Save password and continue'}</button>
      </form>
      <footer>Powered by <strong>Workwise</strong> · Copyright © 2026</footer>
    </section>
  </main>;
}
